import React from 'react';
import SharedAlert from './SharedAlert';
import { IAlertConfig } from '../../../hooks/useSharedAlerts';

export interface IAlertContainerProps {
	alerts: IAlertConfig[];
	onAlertClose: (id: string) => void;
}

const AlertContainer: React.FC<IAlertContainerProps> = ({ alerts, onAlertClose }) => {
	if (!alerts.length) {
		return null;
	}

	return (
		<>
			{alerts.map((alert) => (
				<SharedAlert
					key={alert.id}
					type={alert.type}
					message={alert.message}
					title={alert.title}
					isVisible={true}
					onClose={() => onAlertClose(alert.id)}
					autoDismissTime={alert.autoDismissTime}
					position={alert.position}
					variant={alert.variant}
					className={alert.className}
					panelOffsets={alert.panelOffsets}
					closable={alert.closable}
					zIndex={alert.zIndex}
				/>
			))}
		</>
	);
};

export default AlertContainer;
